import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    productDetails: []
  },

  getters: {
    getProductDetails: state => state.productDetails
  },

  mutations: {
    SET_PRODUCT_DETAILS (state, payload) {
      state.productDetails = payload
    }
  },

  actions: {
    getProductDetailsRefund: ({ commit, state }, payload) => {
      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.getProductDetailsRefund', input: payload }
        ]
      }).then(data => {
        commit('SET_PRODUCT_DETAILS', data[0].output[0])
      })
    },
    getProductDetailsReview: ({ commit, state }, payload) => {
      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.getProductDetailsReview', input: payload }
        ]
      }).then(data => {
        commit('SET_PRODUCT_DETAILS', data[0].output[0])
      })
    },
    createRefundRequest: ({ commit, state }, payload) => {
      // TODO Alex in the future there would be other refund so key how then maybe get portal name frontend?
      const input = {
        sales_order_item_refund_reason: payload.remark,
        sales_order_item_refund_quantity: payload.quantity,
        sales_order_item_refund_amount: payload.amount,
        files: payload.files,
        id: payload.id
      }

      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.createRefundRequest', input: input }
        ]
      }).then(data => {
        return data[0].output
      })
    },
    updateSalesOrderItem: ({ commit, state }, payload) => {
      const input = {
        rel_id: payload
      }
      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.updateRefund', input: input }
        ]
      }).then(data => {
        return data[0].output
      })
    },
    getContentBySalesOrderItemId: ({ commit, state }, payload) => {
      const input = {
        id: payload.rel_id
      }
      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.getContentBySalesOrderItemId', input: input }
        ]
      }).then(data => {
        return data[0].output[0]
      })
    },
    checkIfClassBought: ({ commit, state }, payload) => {
      return ApiUtils.postData({
        data: [
          { api: 'M3001SalesOrderItemService.checkIfClassBought', input: { id: payload } }
        ]
      }).then(data => {
        return data[0].output[0]
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
